import { Injectable } from "@angular/core";
import { NestApiProvider } from "../../nest-api";
import { Observable } from "rxjs";
import { ResponseTokenListsDto } from "../dto/auth.dto";

@Injectable()
export class SessionManagementApi {

  private readonly service: string = 'staging4';
  private readonly model: string = 'sessionmanagement';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public usersWithSession(limit: string | number, page: string | number): Observable<any> {
    const method: string = 'GET';
    const func: string = 'findUsersWithSessions';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof limit !== 'undefined' && limit !== null) urlParams.limit = limit;
    if (typeof page !== 'undefined' && page !== null) urlParams.page = page;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseTokenListsDto>(method, url, func, params, body);
  }

  public userSessionList(limit: string | number, page: string | number, userId: string, accountName: string) {
    const method: string = 'GET';
    const func: string = 'activeUserSessionList';
    const params: any = {
      userId,
      accountName: accountName};
    const urlParams: any = {
      userId,
      accountName: accountName};
    const body: any = {
    };

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseTokenListsDto>(method, url, func, params, body);
  }

  public logoutOtherUser(userId: string, accountName: string, companyCode: string) {
    const method: string = 'POST';
    const func: string = 'logoutOtherUser';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {
      userId,
      accountName: accountName,
      companyCode: companyCode
    };

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseTokenListsDto>(method, url, func, params, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/session-management.api.ts